import { Box, Text } from "@chakra-ui/react"
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";

const NoBrands = ({
  onClickCreateBrandBtn
}) => {
  const { t } = useTranslation();
  return (
    <Box bg="light" paddingInline={4} paddingBlock={8} textAlign="center">
      <Text textTransform="capitalize" color="text" mb={4} fontSize="1.1rem">
        {t("pages.brands.no_data_hint")}
      </Text>
      <GButton
        onClick={onClickCreateBrandBtn}
        size="sm"
        title={t("pages.brands.create_brand")}
        bg="primary"
        color="light"
        border="1px solid transparent"
        hover={{ bg: "none", color: "primary", borderColor: "primary" }}
      />
    </Box>
  )
}

export default NoBrands